class GiftQuantity extends QuantityInput {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.giftWrapping = document.querySelector('gift-wrapping');
    this.perItemMode = this.dataset.perItem === 'true';
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.itemsInCart = parseInt(this.getAttribute('items-in-cart'));

    // If we have nothing but gift-wrap items in the cart.
    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      this.giftWrapping.removeGiftWrap();
    }
    // If we don't have the right amount of gift-wrap items in the cart.
    else if (this.perItemMode && this.giftWrapsInCart > 0 && this.giftWrapsInCart != this.itemsInCart) {
      this.update();
    }
    // If we have a gift-wrap item in the cart but our gift-wrapping cart attribute has not been set.
    else if (this.giftWrapsInCart > 0 && this.giftWrapping.length == 0) {
      this.update();
    }
    // If we have no gift-wrap item in the cart but our gift-wrapping cart attribute has been set.
    else if (this.giftWrapsInCart == 0 && this.giftWrapping.length > 0) {
      this.update();
    }
  }

  update() {
    this.input.value = this.itemsInCart;
    this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('gift-quantity', GiftQuantity);

console.log('🎁 gift-wrapping.js loaded');

class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    console.log('🎁 GiftWrapping constructor called');

    this.miniCart = document.querySelector('mini-cart');
    this.giftWrapId = this.dataset.giftWrapId;
    this.giftWrapVariantInCart = this.dataset.giftWrapVariantInCart || null;
    this.giftWrapping = this.dataset.giftWrapping;
    this.perItemMode = this.dataset.perItem === 'true';
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.itemsInCart = parseInt(this.getAttribute('items-in-cart'));
    this.isProcessing = false; // Flag to prevent concurrent requests
    this.boundBinHandler = null; // Store bound handler reference

    console.log('🎁 GiftWrapping initialized:', {
      giftWrapId: this.giftWrapId,
      giftWrapping: this.giftWrapping,
      giftWrapsInCart: this.giftWrapsInCart,
      itemsInCart: this.itemsInCart
    });

    // When the gift-wrapping buttons are clicked.
    this.addEventListener('click', (event) => {
      console.log('🎁 Click event on gift-wrapping element');
      const button = event.target.closest('[data-gift-action]');
      console.log('🎁 Found button:', !!button, 'action:', button?.dataset?.giftAction);

      if (!button) return;

      // Prevent multiple clicks while processing
      if (this.isProcessing) {
        console.log('⚠️ Already processing, ignoring click');
        event.preventDefault();
        return;
      }

      const action = button.dataset.giftAction;
      console.log('🎁 Executing action:', action);

      if (action === 'add') {
        this.setGiftWrap();
      } else if (action === 'remove') {
        this.removeGiftWrap();
      } else if (action === 'dismiss') {
        this.dismissGiftWrap();
      }
    });

    // Handle bin icon click on gift wrap cart item
    this.setupBinIconHandler();

    // Hide the upsell card if the user dismissed it within the last 24 hours
    if (document.cookie.split(';').some(c => c.trim() === 'gift_wrap_dismissed=1')) {
      const card = this.querySelector('.gift-wrapping__product-card');
      if (card) card.style.display = 'none';
    }

    // Fix inconsistent state: attribute is set but no gift wrap items in cart
    if (this.giftWrapId && this.giftWrapping && this.giftWrapping !== '' && this.giftWrapsInCart == 0) {
      this.removeGiftWrap();
      return;
    }

    // Tier mismatch: gift wrap is in cart but at the wrong price tier — switch it
    if (this.giftWrapsInCart > 0
        && this.giftWrapVariantInCart
        && this.giftWrapVariantInCart !== this.giftWrapId) {
      this.switchGiftWrapVariant();
      return;
    }

    if (this.miniCart) return;

    // If we have nothing but gift-wrap items in the cart.
    if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
      this.removeGiftWrap();
    }
    // If we don't have the right amount of gift-wrap items in the cart.
    else if (this.giftWrapsInCart > 0 && this.giftWrapsInCart != this.itemsInCart) {
      // In flat-rate mode, only sync if quantity is not 1
      if (this.perItemMode || this.giftWrapsInCart != 1) {
        this.setGiftWrap();
      }
    }
    // If we have a gift-wrap item in the cart but our gift-wrapping cart attribute has not been set.
    else if (this.giftWrapsInCart > 0 && this.giftWrapping.length == 0) {
      this.setGiftWrap();
    }
    // If we have no gift-wrap item in the cart but our gift-wrapping cart attribute has been set.
    else if (this.giftWrapsInCart == 0 && this.giftWrapping.length > 0) {
      this.setGiftWrap();
    }
  }

  setGiftWrap() {
    console.log('🎁 setGiftWrap called');
    if (this.isProcessing) {
      console.log('⚠️ Already processing, returning');
      return;
    }
    this.isProcessing = true;
    console.log('🎁 Setting isProcessing = true');

    const loadingOverlay = this.querySelector('.loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.classList.remove('hidden');
    }

    const sections = this.getSectionsToRender().map((section) => section.section);
    const quantity = this.perItemMode ? this.itemsInCart : 1;
    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: quantity
      },
      attributes: {
        'gift-wrapping': true
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((response) => {
        this.isProcessing = false;
        if (loadingOverlay) {
          loadingOverlay.classList.add('hidden');
        }

        if (document.body.classList.contains('template-cart')) {
          window.location.href = window.routes.cart_url;
          return;
        }

        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => {
        this.isProcessing = false;
        console.error('Error adding gift wrap:', e);
        if (loadingOverlay) {
          loadingOverlay.classList.add('hidden');
        }
      });
  }

  switchGiftWrapVariant() {
    if (this.isProcessing) return;
    this.isProcessing = true;

    const sections = this.getSectionsToRender().map((section) => section.section);
    const quantity = this.perItemMode ? this.itemsInCart : 1;
    const body = JSON.stringify({
      updates: {
        [this.giftWrapVariantInCart]: 0,
        [this.giftWrapId]: quantity
      },
      attributes: { 'gift-wrapping': true },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
      })
      .then((response) => {
        this.isProcessing = false;
        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => {
        this.isProcessing = false;
        console.error('Error switching gift wrap tier:', e);
      });
  }

  removeGiftWrap() {
    if (this.isProcessing) return;
    this.isProcessing = true;

    const loadingOverlay = this.querySelector('.loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.classList.remove('hidden');
    }

    const sections = this.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      updates: {
        [this.giftWrapVariantInCart || this.giftWrapId]: 0
      },
      attributes: {
        'gift-wrapping': '',
        'gift-note': ''
      },
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((response) => {
        this.isProcessing = false;
        if (loadingOverlay) {
          loadingOverlay.classList.add('hidden');
        }

        if (document.body.classList.contains('template-cart')) {
          window.location.href = window.routes.cart_url;
          return;
        }

        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch((e) => {
        this.isProcessing = false;
        console.error('Error removing gift wrap:', e);
        if (loadingOverlay) {
          loadingOverlay.classList.add('hidden');
        }
      });
  }

  dismissGiftWrap() {
    const expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `gift_wrap_dismissed=1; expires=${expires}; path=/`;
    const card = this.querySelector('.gift-wrapping__product-card');
    if (card) card.style.display = 'none';
    console.log('🎁 Gift wrap upsell dismissed for 24 hours');
  }

  setupBinIconHandler() {
    // Remove previous handler if it exists
    if (this.boundBinHandler) {
      document.removeEventListener('click', this.boundBinHandler);
    }

    // Create and store the bound handler
    this.boundBinHandler = (event) => {
      // Only handle clicks on links within cart-remove-button elements
      const link = event.target.closest('cart-remove-button a');
      if (!link) return;

      // Check if this is within a gift wrap cart item
      const cartItem = link.closest('li.cart-item--gift-wrap');
      if (!cartItem) return;

      // This is a gift wrap item - handle it with our custom logic
      event.preventDefault();
      event.stopImmediatePropagation();

      if (!this.isProcessing && this.giftWrapId) {
        this.removeGiftWrap();
      }
    };

    // Add the event listener
    document.addEventListener('click', this.boundBinHandler, true);
  }

  disconnectedCallback() {
    // Clean up event listener when element is removed
    if (this.boundBinHandler) {
      document.removeEventListener('click', this.boundBinHandler, true);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];
  }
}
customElements.define('gift-wrapping', GiftWrapping);

class GiftCartNote extends HTMLElement {
  constructor() {
    super();

    console.log('🔵 GiftCartNote constructor called');

    this.miniCart = document.querySelector('mini-cart');
    const textarea = this.querySelector('textarea');
    const button = this.querySelector('button');

    console.log('🔵 Found textarea:', !!textarea, 'name:', textarea?.name);
    console.log('🔵 Found button:', !!button);
    console.log('🔵 Found miniCart:', !!this.miniCart);

    if (textarea && button) {
      console.log('✅ Setting up event listeners');

      // Prevent default onclick from firing until we save
      button.addEventListener('click', (e) => {
        console.log('🟢 Button clicked!');
        e.preventDefault();
        e.stopImmediatePropagation();

        this.saveNote(textarea).then(() => {
          console.log('✅ Save completed, closing details');
          // After saving, close the details manually
          const details = this.closest('details');
          if (details) {
            details.removeAttribute('open');
          }
        }).catch((err) => {
          console.error('❌ Save failed:', err);
        });
      }, true); // Use capture phase to run before inline onclick

      // Also save on change (debounced) as backup
      textarea.addEventListener('change', debounce(() => {
        console.log('🟡 Textarea changed (debounced)');
        this.saveNote(textarea);
      }, 300));
    } else {
      console.warn('⚠️ Missing textarea or button');
    }
  }

  saveNote(textarea) {
    console.log('💾 saveNote called');
    console.log('   Textarea name:', textarea.name);
    console.log('   Textarea value:', textarea.value);

    const isGiftNote = textarea.name.includes('gift-note');
    const isCartNote = textarea.name === 'note';

    console.log('   isGiftNote:', isGiftNote);
    console.log('   isCartNote:', isCartNote);

    let bodyData = {};

    if (isGiftNote) {
      // Gift note - save to attributes[gift-note]
      bodyData.attributes = { 'gift-note': textarea.value };
      console.log('   Saving as gift note');
    } else if (isCartNote) {
      // Cart note - save to note field
      bodyData.note = textarea.value;
      console.log('   Saving as cart note');
    } else {
      console.error('❌ Unknown note type:', textarea.name);
      return Promise.resolve();
    }

    // Add sections for re-rendering
    if (this.miniCart) {
      bodyData.sections = 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble';
      bodyData.sections_url = window.location.pathname;
      console.log('   Added sections for re-rendering');
    }

    const body = JSON.stringify(bodyData);
    console.log('📤 Sending request:', bodyData);
    console.log('   URL:', window.routes.cart_update_url);

    return fetch(`${window.routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then(response => {
        console.log('📥 Response received, status:', response.status);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((response) => {
        console.log('✅ Note saved successfully!');
        console.log('   Response:', response);
        // Re-render cart to show the message
        if (this.miniCart && response.sections) {
          console.log('   Re-rendering cart...');
          this.miniCart.renderContents(response);
        } else {
          console.log('   No miniCart or sections, skipping re-render');
        }
        return response;
      })
      .catch(e => {
        console.error('❌ Error saving note:', e);
        throw e;
      });
  }
}
customElements.define('gift-cart-note', GiftCartNote);
